export default "__VITE_ASSET__hhmQdd5n__"